module.exports = __webpack_public_path__ + "img/camera-de-seguranca.d887a4ed.svg";